import { Link } from "react-router-dom";
import styles from "./Stub.module.css";
import { NoEventsSvg } from "../../img/Image";


export const Stub = () => {
    return (
        <div className={styles.container}>
            <div className={styles.headerContainer}>
                <div className={styles.blockInfo}>
                    <div className={styles.welcomContendRegistrate}>
                        <h1
                            className={styles.completeTitle}
                        >
                            Пока ближайших событий нет!
                        </h1>
                        <div className={styles.letter}>
                            <NoEventsSvg className={styles.letterImg} />
                        </div>
                        <p className={styles.completeText} >
                            Информацию о предстоящих мероприятиях можете посмотреть на сайте <a href="https://vftmfest.ru/">vftmfest</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const StubMyEvents = () => {
    return (
        <div className={styles.container}>
            <div className={styles.headerContainer}>
                <div className={styles.blockInfo}>
                    <div className={styles.welcomContendRegistrate}>
                        <h1
                            className={styles.completeTitle}
                        >
                            Вы не отправили ни одну заявку!
                        </h1>
                        <div className={styles.letter}>
                            <NoEventsSvg className={styles.letterImg} />
                        </div>
                        <p className={styles.completeText} >
                            Чтобы подать заявку перейдите в раздел <Link to="/" className={styles.profileLink}>ближайшие события</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}